import { FormatterType } from '@components/Table/types';
import { ExpressionTypes } from '../../views/CustomDashboards/types';
import { FieldTypes } from '../../views/Reports/types';
import { DateOptionsProps } from './popupByType/DateOptions';

export type FieldOptionsType = FieldTypes.Measurement | FormatterType.date;

export type MetricType = FieldTypes.Measurement;
export type DateType = FormatterType.date;

export type AllFieldsTypeUnion = MetricType | DateType;

export interface MetricOptionsType {
  type: MetricType;
}
export interface DateOptionsType extends DateOptionsProps {
  type: DateType;
}
export interface OptionalType {
  type?: unknown;
}

export type AllOptionsType = DateOptionsType | MetricOptionsType;

export const isDateType = (type, props): props is DateOptionsType => type === FormatterType.date;

export interface SelectedField {
  expression?: ExpressionTypes;
  value: string;
}

export type SelectedFieldsType = Record<string, SelectedField>;
